/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {NavigationGuard} from 'vue-router';
import {RawLocation, Route} from 'vue-router/types/router';
import {Vue} from 'vue-property-decorator';
import store from '@/store';

/**
 * Authentication route guard.
 *
 * Note: if the jwt token is not undefined or empty then it is presumed that the JWT is valid.
 *
 * @param to
 * @param from
 * @param next
 */
export const eliteGuard: NavigationGuard = (
    to: Route,
    from: Route,
    next: (to?: RawLocation | false | ((vm: Vue) => any) | void) => void,
): void => {
    if (!!to.query.token) {
        store.commit('userSessionModule/setToken', to.query.token);
        store.dispatch('userSessionModule/decode', to.query.token).finally(() => {
            next(to.path);
        });
    }

    next();
};
